import { Outlet } from "react-router-dom";
import Navbar from "../Components/userComponents/Navbar/Navbar";
import Footer from "../Components/userComponents/Common/Footer";

const ClientLayout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default ClientLayout;
